<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('privacy') }}
    </h1>
    <span v-if="lang_mobiz == 'arabic'">
      <privacy-arabic/>
    </span>
    <span v-else-if="lang_mobiz == 'malay'">
      <privacy-malay/>
    </span>
    <span v-else-if="lang_mobiz == 'greek'">
      <privacy-greek/>
    </span>
    <span v-else-if="lang_mobiz == 'czech'">
      <privacy-czech/>
    </span>
    <span v-else-if="lang_mobiz == 'bulgarian'">
      <privacy-bulgarian/>
    </span>
    <span v-else-if="lang_mobiz == 'norwegian'">
      <privacy-norwegian/>
    </span>
    <span v-else>
      <privacy-english/>
    </span>
  </div>
</template>

<script>
import PrivacyPolicyEnglish from './../PrivacyPolicyEnglish';
import PrivacyPolicyArabic from './../PrivacyPolicyArabic';
import PrivacyPolicyMalay from './../PrivacyPolicyMalay';
import PrivacyPolicyGreek from './../PrivacyPolicyGreek';
import PrivacyPolicyCzech from './../PrivacyPolicyCzech';
import PrivacyPolicyBulgarian from './../PrivacyPolicyBulgarian';
import PrivacyPolicyNorwegian from './../PrivacyPolicyNorwegian';
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["lang_mobiz", "country_mobiz"]),
  components:{
    'privacy-english': PrivacyPolicyEnglish,
    'privacy-arabic': PrivacyPolicyArabic,
    'privacy-malay': PrivacyPolicyMalay,
    'privacy-greek': PrivacyPolicyGreek,
    'privacy-czech': PrivacyPolicyCzech,
    'privacy-bulgarian': PrivacyPolicyBulgarian,
    'privacy-norwegian': PrivacyPolicyNorwegian
  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
.mobiFaq {
  margin: 25px 0px;
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
  }
  .mobiTitle {
    padding: 12px;
    background: #f1f1f1;
  }
  li {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 300;
    margin-bottom: 8px;
  }
}

.ar_layout {
}
</style>


// WEBPACK FOOTER //
// src/components/mobizone/PrivacyPolicy.vue